export { default as GDMIconButton } from './GDMIconButton';

export type {
  GDMIconButtonComponent,
  GDMIconButtonProps,
  IGDMIconButtonProps,
} from './GDMIconButton.type';
